exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".deck-hud-button{transition-property:transform,color,opacity;transition-duration:.25s;transition-timing-function:ease-in}.deck-hud-button:hover{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/session/presentation/spectacle-ppa/src/deck.scss
// module id = 1316
// module chunks = 2